function getConfig(name, defaultValue) {
  if (
    typeof window !== 'undefined' &&
    window.ENV &&
    Object.prototype.hasOwnProperty.call(window.ENV, name)
  ) {
    const v = window.ENV[name];
    if (v !== undefined && v !== '') return v;
  }
  const envVal = typeof process !== 'undefined' ? process.env?.[name] : undefined;
  return envVal !== undefined && envVal !== '' ? envVal : defaultValue;
}

export function getBackendUrl() {
  return getConfig('REACT_APP_BACKEND_URL');
}

/** URL da imagem pública (login/cadastro/terms). Aceita só nome do arquivo ou path relativo. */
export function getPublicImageUrl(value) {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  // blob: e data: são URLs locais do browser — não enviar ao backend
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return trimmed;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const base = (getBackendUrl() || '').replace(/\/$/, '');
  const path = trimmed.startsWith('public/') ? trimmed : `public/${trimmed}`;
  return `${base}/${path}`;
}

export function getHoursCloseTicketsAuto() {
  return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
  return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
  return getConfig('REACT_APP_PRIMARY_COLOR');
}

export function getPrimaryDark() {
  return getConfig('REACT_APP_PRIMARY_DARK');
}

export function getNumberSupport() {
  return getConfig('REACT_APP_NUMBER_SUPPORT');
}
